import AboutHero from "./components/AboutHero";
import TrustBar from "../../components/feature/TrustBar";
import StephanieStory from "./components/StephanieStory";
import AIAnswerBlock from "../../components/feature/AIAnswerBlock";
import ProcessSection from "../../components/feature/ProcessSection";
import WhyChooseUs from "../home/components/WhyChooseUs";
import ServiceAreasSection from "../../components/feature/ServiceAreasSection";
import TestimonialsSection from "../../components/feature/TestimonialsSection";
import FAQSection from "../../components/feature/FAQSection";
import FinalCTASection from "../../components/feature/FinalCTASection";
import MidPageCTA from "../../components/feature/MidPageCTA";
import { aboutFaqs } from "../../mocks/faq";

const aboutTrust = [
  { number: "15+", label: "Years Experience", icon: "ri-award-line" },
  { number: "500+", label: "Families Served", icon: "ri-heart-line" },
  { number: "SA", label: "Based in San Antonio", icon: "ri-map-pin-line" },
  { number: "5★", label: "Client Rating", icon: "ri-star-line" },
];

const aboutAI = {
  title: "About Precious Keepsakes",
  subtitle: "Who we are & what we believe",
  what: "Precious Keepsakes Photography is a fine art portrait studio led by photographer Stephanie, based in San Antonio, Texas. With 15+ years of experience, Stephanie specializes in creating heirloom-quality imagery for newborns, weddings, and life's most important milestones.",
  services: [
    "Newborn & maternity photography — studio and on-location",
    "Luxury wedding photography — full and partial day coverage",
    "Senior portraits — modern and authentic",
    "Quinceañera & Sweet 16 sessions",
    "Family lifestyle and milestone sessions",
  ],
  benefits: [
    "Personal, guided approach — every session is stress-free",
    "15+ years of fine art photography expertise",
    "Genuine connection-first philosophy",
    "Premium heirloom products included",
    "On-location availability throughout San Antonio",
  ],
  process: [
    "Connect — reach out via phone or inquiry form",
    "Consult — personal conversation about your vision",
    "Create — beautifully guided session experience",
    "Treasure — receive your heirloom gallery and prints",
  ],
};

export default function AboutPage() {
  return (
    <main>
      <AboutHero />
      <TrustBar items={aboutTrust} />
      <StephanieStory />
      <MidPageCTA
        headline="Every Session Begins With a Personal Conversation"
        subtext="Stephanie takes the time to understand your vision before the first shutter click. Your keepsakes are crafted with intention."
        ctaLabel="Meet Stephanie &amp; Begin"
        secondaryLabel="View Our Services"
        secondaryHref="/services"
      />
      <AIAnswerBlock {...aboutAI} />
      <ProcessSection title="How Every Session Unfolds" subtitle="A personal, thoughtful process from first hello to final delivery" />
      <WhyChooseUs />
      <ServiceAreasSection />
      <TestimonialsSection title="Stories From Our Families" />
      <FAQSection faqs={aboutFaqs} title="About the Studio" subtitle="Common questions about Precious Keepsakes Photography" />
      <FinalCTASection
        title="Let&apos;s Create Something Meaningful Together"
        subtitle="Your family&apos;s story deserves to be told with intention. Reach out and let&apos;s begin."
        ctaLabel="Create Your Custom Keepsake"
        backgroundImage="https://images-pw.pixieset.com/site/BAJyQr/6wqeRl/001-20210522-c4d5e457-1500.jpg"
      />
    </main>
  );
}